module.exports = __webpack_public_path__ + "static/media/BDS.d1c1a08c.pdf";